import { render, staticRenderFns } from "./AutomaticReportDetailsTable.vue?vue&type=template&id=b3550a4e&"
import script from "./AutomaticReportDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./AutomaticReportDetailsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports